"use strict";



/**
 * Unlockcurse list. This is always referenced dynamically when the restraint is picked up
 */
let KDCurseUnlockList = {
	"Common": [
		"ShrineWill",
		"ShrineIllusion",
		"ShrineElements",
		"ShrineConjure",
		"BlueLock",
		"Will",
		"TakeDamageFire",
		"TakeDamageElectric",
		"TakeDamageIce",
		"TakeDamageGlue",
		"TakeDamageChain",
		"OrgasmResist",
		"Mana",
		"SacrificeMage",
	],
	"Dragon": [
		"ShrineWill",
		"ShrineIllusion",
		"ShrineElements",
		"ShrineConjure",
	],
	"Divine": [
		"ShrineWill",
		"ShrineIllusion",
		"ShrineElements",
		"ShrineConjure",
		"OrgasmResist",
		"SacrificeMage",
	],
	"CursedCollar": [
		"CursedDamage",
	],
	"CursedCollar2": [
		"CursedDamage",
	],
	"LatexKittyCurse": [
		"LatexKittyCurse",
	]
};

/**
 * onApply: occurs when applied
 * condition: required to remove it
 * remove: happens when removing
 * events: these events are added to the restraint
 */
let KDCurses: Record<string, KDCursedDef> = {
	"GhostLock" : {
		powerMult: 5,
		lock: true,
		level: 10,
		weight: (_item) => {
			return 1;
		},
		condition: (_item) => {
			return KinkyDungeonItemCount("Ectoplasm") >= 25;
		},
		remove: (_item, _host, _specialMethod) => {
			if (!_specialMethod)
				KinkyDungeonChangeConsumable(KinkyDungeonConsumables.Ectoplasm, -25);
		},

		
		entityCanUnlock(entity, player, data) {
			return !KDHelpless(entity) && 
				(
					entity.Enemy?.Security?.level_magic >= 4
				);
		},
		entityDoUnlock(entity, player, data) {
			return true;
		},
	},
	"DollLock" : {
		powerMult: 4,
		lock: true,
		level: 15,
		weight: (_item) => {
			return 1;
		},
		condition: (_item) => {
			return KinkyDungeonItemCount("DollID") >= 4;
		},
		remove: (_item, _host, _specialMethod) => {
			if (!_specialMethod)
				KinkyDungeonChangeConsumable(KinkyDungeonConsumables.DollID, -4);
		},
		entityCanUnlock(entity, player, data) {
			return !KDHelpless(entity) && 
				(
					entity.Enemy?.Security?.level_tech >= 3
				);
		},
		entityDoUnlock(entity, player, data) {
			return true;
		},
	},
	"SpellLock1" : {
		powerMult: 2.8,
		lock: true,
		level: 4,
		weight: (_item) => {
			return 1;
		},
		condition: (_item) => {
			return KinkyDungeonSpellPoints > 0;
		},
		remove: (_item, _host, _specialMethod) => {
			if (!_specialMethod)
				KinkyDungeonSpellPoints -= 1;
		},
		entityCanUnlock(entity, player, data) {
			return !KDHelpless(entity) && 
				(
					entity.Enemy?.Security?.level_magic >= 2
				);
		},
		entityDoUnlock(entity, player, data) {
			return true;
		},
	},
	"SpellLock8" : {
		powerMult: 4,
		lock: true,
		level: 12,
		weight: (_item) => {
			return 1;
		},
		condition: (_item) => {
			let amount = KinkyDungeonStatsChoice.get("randomMode") ? 3 : 8;
			return KinkyDungeonSpellPoints >= amount;
		},
		remove: (_item, _host, _specialMethod) => {
			if (!_specialMethod) {
				let amount = KinkyDungeonStatsChoice.get("randomMode") ? 3 : 8;
				KinkyDungeonSpellPoints -= amount;
			}
		},
		customInfo: (item, Curse) => {
			let amount = KinkyDungeonStatsChoice.get("randomMode") ? 3 : 8;
			KinkyDungeonSendActionMessage(4, TextGet("KinkyDungeonCurseInfo" + Curse)
				.replace("RestraintName", KDGetItemName(item))//TextGet("Restraint" + KDRestraint(item).name))
				.replace("AMNT", "" + (amount)),
			KDBaseWhite, 2);
		},
		entityCanUnlock(entity, player, data) {
			return !KDHelpless(entity) && 
				(
					entity.Enemy?.Security?.level_magic >= 3
				);
		},
		entityDoUnlock(entity, player, data) {
			return true;
		},
	},
	
	LatexKittyCurse: {
		powerMult: 3.8,
		lock: true,
		noShrine: true,
		activatecurse: true,
		level: 5,
		customIcon_hud: "LatexKittyCurse",
		weight: (_item) => {
			return 1;
		},
		condition: (item) => {
			return (KDItemDataQuery(item, "LatexKittyCurseHP") || 0) <= 0;
		}, 
		onApply: (item, _host) => {
			KDItemDataSet(item, "LatexKittyCurseHP", Math.max(1, KDRestraint(item)?.power)
				+ Math.max(1, KDRandom() * KDGetEffLevel())**0.7)
		},
		remove: (_item, _host) => {},
		customInfo: (item, Curse) => {
			KinkyDungeonSendActionMessage(4, TextGet("KinkyDungeonCurseInfo" + Curse)
				.replace("RestraintName", KDGetItemName(item))//TextGet("Restraint" + KDRestraint(item).name))
				.replace("AMNT", 
					"" + (Math.round(10 * ((KDItemDataQuery(item, "LatexKittyCurseHP") || 0))) || 0)),
			KDBaseWhite, 2);
		},
		events: [
			{type: "LatexKittyCurse", power: 2, addBind: true, damage: "glue", bindType: "Latex", bindEff: 2.0, trigger: "playerAttack"},
			{type: "LatexKittyCurse", trigger: "tick"},
		],
		entityCanUnlock(entity, player, data) {
			return !KDHelpless(entity) && 
				(
					entity.Enemy?.Security?.level_magic >= 2
				);
		},
		entityDoUnlock(entity, player, data) {
			// TODO add a chance to spread the curse?
			return true;
		},
	},
	"CursedCollar": {
		powerMult: 10,
		lock: true,
		noShrine: true,
		activatecurse: true,
		level: 30,
		customIcon_hud: "StarCurse",
		weight: (_item) => {
			return 1;
		},
		condition: (_item) => {
			for (let inv of KinkyDungeonAllRestraintDynamic()) {
				if (KDGetCurse(inv.item) == "CursedDamage") return false;
			}
			return true;
		},
		remove: (_item, _host) => {
			//KinkyDungeonChangeConsumable(KinkyDungeonConsumables.MistressKey, -1);
		},
		entityCanUnlock(entity, player, data) {
			return !KDHelpless(entity) && 
				(
					entity.Enemy?.Security?.level_key >= 3
				);
		},
		entityDoUnlock(entity, player, data) {
			return true;
		},
	},
	"CursedDamage": {
		powerMult: 10,
		lock: true,
		noShrine: true,
		activatecurse: true,
		level: 9,
		customIcon_hud: "StarCurse",
		weight: (_item) => {
			return 1;
		},
		condition: (_item) => {
			return false;
		},
		remove: (_item, _host) => {},
		customInfo: (item, Curse) => {
			KinkyDungeonSendActionMessage(4, TextGet("KinkyDungeonCurseInfo" + Curse)
				.replace("RestraintName", KDGetItemName(item))//TextGet("Restraint" + KDRestraint(item).name))
				.replace("AMNT", "" + (Math.round(10 * ((KDItemDataQuery(item, "cursedDamageHP") || 0) - (KDItemDataQuery(item, "cursedDamage") || 0))) || "???")),
			KDBaseWhite, 2);
		},
		events: [
			{type: "cursedDamage", trigger: "afterPlayerDamage", mult: 1.0, power: 20, limit: 40},
		],
		entityCanUnlock(entity, player, data) {
			return !KDHelpless(entity) && 
				(
					entity.Enemy?.Security?.level_magic >= 3
					|| entity.Enemy?.tags?.demon
				);
		},
		entityDoUnlock(entity, player, data) {
			return true;
		},
	},
	"MistressKey": {
		powerMult: 4,
		lock: true,
		noShrine: true,
		customIcon_RemoveFailure: "Locks/Gold",
		level: 10,
		blockable: true,
		weight: (_item) => {
			return 1;
		},
		condition: (_item) => {
			return KinkyDungeonItemCount("MistressKey") > 0;
		},
		remove: (_item, _host, _specialMethod) => {
			if (!_specialMethod)
				KinkyDungeonChangeConsumable(KinkyDungeonConsumables.MistressKey, -1);
		},
		entityCanUnlock(entity, player, data) {
			return !KDHelpless(entity) && 
				(
					entity.Enemy?.tags?.ancientmistress
				);
		},
		entityDoUnlock(entity, player, data) {
			return true;
		},
	},
	"5Keys" : {
		lock: true,
		level: 3,
		powerMult: 2.4,
		blockable: true,
		weight: (_item) => {
			return 3;
		},
		condition: (_item) => {
			return KinkyDungeonItemCount("RedKey") >= 5;
		},
		remove: (_item, _host, _specialMethod) => {
			if (!_specialMethod)
				KDAddConsumable("RedKey", -5);
		},
		entityCanUnlock(entity, player, data) {
			return !KDHelpless(entity) && 
				(
					entity.Enemy?.Security?.level_key >= 2
					|| KDEnemyRank(entity) >= 3
				);
		},
		entityDoUnlock(entity, player, data) {
			return true;
		},
	},
	"Key" : {
		powerMult: 2.1,
		lock: true,
		level: 1,
		blockable: true,
		weight: (_item) => {
			return 10;
		},
		condition: (_item) => {
			return KinkyDungeonItemCount("RedKey") >= 1;
		},
		remove: (_item, _host, _specialMethod) => {
			if (!_specialMethod)
				KDAddConsumable("RedKey", -1);
		},
		entityCanUnlock(entity, player, data) {
			return !KDHelpless(entity) && 
				(
					entity.Enemy?.Security?.level_key >= 1
					|| KDEnemyRank(entity) >= 2
				);
		},
		entityDoUnlock(entity, player, data) {
			return true;
		},
	},
	"BlueLock" : {
		lock: true,
		activatecurse: true,
		level: 4,
		blockable: true,
		weight: (_item) => {
			return 10;
		},
		condition: (_item) => {
			return KinkyDungeonItemCount("BlueKey") >= 1;
		},
		remove: (_item, _host, _specialMethod) => {
			if (!_specialMethod)
				KDAddConsumable("BlueKey", -1);
		},
		entityCanUnlock(entity, player, data) {
			return !KDHelpless(entity) && 
				(
					entity.Enemy?.Security?.level_magic >= 3
					|| entity.Enemy?.unlockCommandLevel >= 3
				);
		},
		entityDoUnlock(entity, player, data) {
			return true;
		},
	},
	"TakeDamageFire" : {
		powerMult: 2.2,
		activatecurse: true,
		level: 4,
		weight: (_item) => {
			return 10;
		},
		condition: (_item) => {return false;},
		remove: (_item, _host) => {},
		events: [
			{type: "RemoveOnDmg", power: 1, count: 3, damage: "fire", trigger: "beforePlayerDamage", kind: "CurseMelt"},
			{type: "RemoveOnDmg", power: 1, count: 3, damage: "crush", trigger: "beforePlayerDamage", kind: "CurseMelt"},
		],
		entityCanUnlock(entity, player, data) {
			return !KDHelpless(entity) && 
				(
					entity.Enemy?.Security?.level_magic >= 1
					|| entity.Enemy?.unlockCommandLevel >= 2
				);
		},
		entityDoUnlock(entity, player, data) {
			return true;
		},
	},
	"TakeDamageIce" : {
		powerMult: 2.2,
		activatecurse: true,
		level: 4,
		weight: (_item) => {
			return 10;
		},
		condition: (_item) => {return false;},
		remove: (_item, _host) => {},
		events: [
			{type: "RemoveOnDmg", power: 1, count: 4, damage: "ice", trigger: "beforePlayerDamage", kind: "CurseExtinguish"},
			{type: "RemoveOnDmg", power: 1, mult: 0.5, count: 4, damage: "acid", trigger: "beforePlayerDamage", kind: "CurseExtinguish"},
			{type: "RemoveOnDmg", power: 1, mult: 0.5, count: 4, damage: "soap", trigger: "beforePlayerDamage", kind: "CurseExtinguish"},
			{type: "RemoveOnETTag", power: 0.1, count: 4, tags: ["ice"], trigger: "tickAfter", kind: "CurseExtinguish"},
			{type: "RemoveOnETTag", power: 0.4, count: 4, tags: ["water"], trigger: "tickAfter", kind: "CurseExtinguish"},
			//{type: "RemoveOnBuffName", trigger: "tick", kind: "Drenched"},
			//{type: "RemoveOnBuffName", trigger: "tick", kind: "Chilled"},
		],
		entityCanUnlock(entity, player, data) {
			return !KDHelpless(entity) && 
				(
					entity.Enemy?.Security?.level_magic >= 1
					|| entity.Enemy?.unlockCommandLevel >= 2
				);
		},
		entityDoUnlock(entity, player, data) {
			return true;
		},
	},
	"TakeDamageElectric" : {
		powerMult: 2.2,
		activatecurse: true,
		level: 4,
		weight: (_item) => {
			return 10;
		},
		condition: (_item) => {return false;},
		remove: (_item, _host) => {},
		events: [
			{type: "RemoveOnDmg", power: 1, count: 2, damage: "electric", trigger: "beforePlayerDamage", kind: "CurseShock"},
			{type: "RemoveOnDmg", power: 1, count: 2, damage: "estim", trigger: "beforePlayerDamage", kind: "CurseShock"},
		],
		entityCanUnlock(entity, player, data) {
			return !KDHelpless(entity) && 
				(
					entity.Enemy?.Security?.level_magic >= 1
					|| entity.Enemy?.unlockCommandLevel >= 2
				);
		},
		entityDoUnlock(entity, player, data) {
			return true;
		},
	},
	"TakeDamageGlue" : {
		powerMult: 2.2,
		activatecurse: true,
		level: 4,
		weight: (_item) => {
			return 10;
		},
		condition: (_item) => {return false;},
		remove: (_item, _host) => {},
		events: [
			{type: "RemoveOnDmg", power: 1, count: 5, damage: "glue", trigger: "beforePlayerDamage", kind: "CurseGlue"}
		],
		entityCanUnlock(entity, player, data) {
			return !KDHelpless(entity) && 
				(
					entity.Enemy?.Security?.level_magic >= 1
					|| entity.Enemy?.unlockCommandLevel >= 2
				);
		},
		entityDoUnlock(entity, player, data) {
			return true;
		},
	},
	"TakeDamageChain" : {
		powerMult: 2.2,
		activatecurse: true,
		level: 4,
		weight: (_item) => {
			return 10;
		},
		condition: (_item) => {return false;},
		remove: (_item, _host) => {},
		events: [
			{type: "RemoveOnDmg", power: 1, count: 5, damage: "chain", trigger: "beforePlayerDamage", kind: "CurseChain"}
		],
		entityCanUnlock(entity, player, data) {
			return !KDHelpless(entity) && 
				(
					entity.Enemy?.Security?.level_magic >= 1
					|| entity.Enemy?.unlockCommandLevel >= 2
				);
		},
		entityDoUnlock(entity, player, data) {
			return true;
		},
	},
	"SacrificeMage" : {
		powerMult: 2.5,
		activatecurse: true,
		level: 6,
		weight: (_item) => {
			return 10;
		},
		condition: (_item) => {return false;},
		remove: (_item, _host) => {},
		events: [
			{type: "SacrificeMage", power: 1, count: 5, mult: 1, trigger: "afterCapture", kind: "SacrificeMage"}
		],
		entityCanUnlock(entity, player, data) {
			return !KDHelpless(entity) && 
				(
					entity.Enemy?.Security?.level_magic >= 2
					|| entity.Enemy?.unlockCommandLevel >= 3
				);
		},
		entityDoUnlock(entity, player, data) {
			return true;
		},
	},
	"Will" : {
		powerMult: 2,
		activatecurse: true,
		level: 2,
		weight: (_item) => {
			return 10;
		},
		onApply: (_item, _host) => {
			KDChangeWill("Will", "curse", "curse", -1);
		},
		condition: (_item) => {
			return KinkyDungeonStatWill >= KinkyDungeonStatWillMax*0.99;
		},
		remove: (_item, _host) => {
			// For free!
		},
		entityCanUnlock(entity, player, data) {
			return !KDHelpless(entity) && 
				(
					entity.Enemy?.Security?.level_magic >= 2
					|| entity.Enemy?.unlockCommandLevel >= 3
				);
		},
		entityDoUnlock(entity, player, data) {
			return true;
		},
	},
	"Mana" : {
		powerMult: 2,
		activatecurse: true,
		level: 2,
		weight: (_item) => {
			return 10;
		},
		condition: (_item) => {
			return KinkyDungeonStatMana + KinkyDungeonStatManaPool >= 20;
		},
		remove: (_item, _host, _specialMethod) => {
			if (!_specialMethod)
				KDChangeMana("Mana", "curse", "uncurse", -20, false, 0, true, true);
		},
		entityCanUnlock(entity, player, data) {
			return !KDHelpless(entity) && 
				(
					entity.Enemy?.Security?.level_magic >= 1
					|| entity.Enemy?.unlockCommandLevel >= 1
				);
		},
		entityDoUnlock(entity, player, data) {
			return true;
		},
	},
	"ShrineWill" : {
		powerMult: 2.5,
		activatecurse: true,
		level: 2,
		weight: (_item) => {
			return 10;
		},
		events: [
			{type: "ShrineUnlockWiggle", trigger: "tick", kind: "ShrineWill"}
		],
		entityCanUnlock(entity, player, data) {
			return !KDHelpless(entity) && 
				(
					entity.Enemy?.Security?.level_magic >= 2
					|| entity.Enemy?.tags?.angel
				);
		},
		entityDoUnlock(entity, player, data) {
			return true;
		},
		condition: (_item) => {
			return KDNearbyTiles(KinkyDungeonPlayerEntity.x, KinkyDungeonPlayerEntity.y, 1.5).some((tile) => {
				return tile?.tile?.Type == "Shrine" && tile.tile.Name == "Will";
			});
		}, remove: (_item, _host) => {/* For free! */}},
	"ShrineElements" : {
		powerMult: 2.5,
		activatecurse: true,
		level: 2,
		weight: (_item) => {
			return 10;
		},
		events: [
			{type: "ShrineUnlockWiggle", trigger: "tick", kind: "ShrineElements"}
		],
		entityCanUnlock(entity, player, data) {
			return !KDHelpless(entity) && 
				(
					entity.Enemy?.Security?.level_magic >= 2
					|| entity.Enemy?.tags?.angel
				);
		},
		entityDoUnlock(entity, player, data) {
			return true;
		},
		condition: (_item) => {
			return KDNearbyTiles(KinkyDungeonPlayerEntity.x, KinkyDungeonPlayerEntity.y, 1.5).some((tile) => {
				return tile?.tile?.Type == "Shrine" && tile.tile.Name == "Elements";
			});
		}, remove: (_item, _host) => {/* For free! */}},
	"ShrineConjure" : {
		powerMult: 2.5,
		activatecurse: true,
		level: 2,
		weight: (_item) => {
			return 10;
		},
		events: [
			{type: "ShrineUnlockWiggle", trigger: "tick", kind: "ShrineConjure"}
		],
		entityCanUnlock(entity, player, data) {
			return !KDHelpless(entity) && 
				(
					entity.Enemy?.Security?.level_magic >= 2
					|| entity.Enemy?.tags?.angel
				);
		},
		entityDoUnlock(entity, player, data) {
			return true;
		},
		condition: (_item) => {
			return KDNearbyTiles(KinkyDungeonPlayerEntity.x, KinkyDungeonPlayerEntity.y, 1.5).some((tile) => {
				return tile?.tile?.Type == "Shrine" && tile.tile.Name == "Conjure";
			});
		}, remove: (_item, _host) => {/* For free! */}},
	"ShrineIllusion" : {
		powerMult: 2.5,
		activatecurse: true,
		level: 2,
		weight: (_item) => {
			return 10;
		},
		events: [
			{type: "ShrineUnlockWiggle", trigger: "tick", kind: "ShrineIllusion"}
		],
		entityCanUnlock(entity, player, data) {
			return !KDHelpless(entity) && 
				(
					entity.Enemy?.Security?.level_magic >= 2
					|| entity.Enemy?.tags?.angel
				);
		},
		entityDoUnlock(entity, player, data) {
			return true;
		},
		condition: (_item) => {
			return KDNearbyTiles(KinkyDungeonPlayerEntity.x, KinkyDungeonPlayerEntity.y, 1.5).some((tile) => {
				return tile?.tile?.Type == "Shrine" && tile.tile.Name == "Illusion";
			});
		}, remove: (_item, _host) => {/* For free! */}},
	"OrgasmResist" : {
		powerMult: 2.9,
		activatecurse: true,
		level: 5,
		weight: (_item) => {
			return KinkyDungeonStatsChoice.get("arousalMode") ? 7 : 0;
		},
		entityCanUnlock(entity, player, data) {
			return !KDHelpless(entity) && 
				(
					entity.Enemy?.Security?.level_magic >= 1
				);
		},
		entityDoUnlock(entity, player, data) {
			return true;
		},
		condition: (_item) => {return false;},
		remove: (_item, _host) => {},
		events: [
			{type: "RemoveOnEdge", power: 1, count: 50, trigger: "tick", kind: "OrgasmResist", msg: "KDRemoveOnEdge"},
			{type: "IncrementRemovalVar", power: 3, count: 50, trigger: "edge", kind: "OrgasmResist", msg: "KDRemoveOnEdgeSucceed"},
			{type: "IncrementRemovalVar", power: -25, count: 50, trigger: "orgasm", kind: "OrgasmResist", msg: "KDRemoveOnEdgeFail"},
		],
	},
	"HaveOrgasm" : {
		powerMult: 2.5,
		activatecurse: true,
		level: 5,
		weight: (_item) => {
			return KinkyDungeonStatsChoice.get("arousalMode") ? 9 : 0;
		},
		entityCanUnlock(entity, player, data) {
			return !KDHelpless(entity) && 
				(
					entity.Enemy?.Security?.level_magic >= 1
				);
		},
		entityDoUnlock(entity, player, data) {
			return true;
		},
		condition: (_item) => {return false;},
		remove: (_item, _host) => {},
		events: [
			{type: "IncrementRemovalVar", power: 25, count: 50, trigger: "orgasm", kind: "HaveOrgasm", msg: "KDRemoveOnOrgasmFail"},
		],
	},
};



/**
 * TODO
curseInfoAnimation,"Curse of Animation: Causes loose restraints to animate and attack you!"
curseInfoSensitivity,"Curse of Sensitivity: Makes it easier to lose control of yourself."
 */

/** Cursed variants of restraints
 */
let KDCursedVars: Record<string, KDCursedVar> = {
	"Common": {
		level: 1,
		variant: (restraint, newRestraintName) => {
			return KDAddEventVariant(restraint, newRestraintName, [
				// We add this to ALL cursed items (including dormant curses)
				{trigger: "curseCount", type: "add", power: 1, inheritLinked: true,
					removeOnUncurse: true},
			], 4, restraint.DefaultLock || "", {commonCurse: 10});
		}
	},
	"Skimpy": {
		level: 1,
		variant: (restraint, newRestraintName) => {
			let ret = KDAddEventVariant(restraint, newRestraintName, [
				// We add this to ALL cursed items (including dormant curses)
				{trigger: "curseCount", type: "add", power: 1, inheritLinked: true,
					removeOnUncurse: true},
				{original: "MimicHoly", trigger: "inventoryTooltip",
					type: "invtooltipworn", msg: "SkimpyCurse", color: "#000044", bgcolor: KDBaseWhite,
					removeOnUncurse: true},
			], 4, restraint.DefaultLock || "", {});
			if (KDSkimpyModelReplace[restraint.Model]) {
				KDSkimpyModelReplace[restraint.Model](ret, restraint, newRestraintName);
			}
			return ret;
		}
	},
	"Mimic": {
		level: 2,
		variant: (restraint, newRestraintName) => {
			return KDAddEventVariant(restraint, newRestraintName, [
				// We add this to ALL cursed items (including dormant curses)
				{trigger: "curseCount", type: "add", power: 1, inheritLinked: true,
					removeOnUncurse: true},
				{trigger: "tick", type: "mimiccurse", time: 10, chance: 0.2, sfx: "Evil",
					inheritLinked: true, removeOnUncurse: true},
			], 8, restraint.DefaultLock || "", {mimicCurse: 10});
		}
	},
	"MimicHoly": {
		level: 2,
		variant: (restraint, newRestraintName) => {
			return KDAddEventVariant(restraint, newRestraintName, [
				// We add this to ALL cursed items (including dormant curses)
				{trigger: "curseCount", type: "add", power: 1, inheritLinked: true,
					removeOnUncurse: true},
				{trigger: "tick", type: "mimiccurse", time: 10, chance: 0.2, sfx: "Evil",
					inheritLinked: true, removeOnUncurse: true},
				{trigger: "cleanse", type: "RemoveAndRevert", kind: restraint.name, sfx: "Magic",
					inheritLinked: true},
				{original: "MimicHoly", trigger: "inventoryTooltip",
					type: "invtooltipworn", msg: "MimicHolyGlow", color: "#000044", bgcolor: "#ffff88",
					removeOnUncurse: true},

			], 8, restraint.DefaultLock || "", {divinemimicCurse: 10});
		}
	},
	"Shibari": {
		level: 2,
		variant: (restraint, newRestraintName) => {
			let ret = KDAddEventVariant(restraint, newRestraintName, [
				// We add this to ALL cursed items (including dormant curses)
				{trigger: "curseCount", type: "add", power: 1, inheritLinked: true,
					removeOnUncurse: true},
				{original: "MimicHoly", trigger: "inventoryTooltip",
					type: "invtooltipworn", msg: "ShibariCurse", color: "#000044", bgcolor: KDBaseWhite,
					removeOnUncurse: true},
			], 8, restraint.DefaultLock || "", {shibariCurse: 10});
			let mapGroup = KDRopeMapByGroup;
			if (!ret.alwaysDressModel) ret.alwaysDressModel = [];
			ret.alwaysDressModel.push(
				{
					Model: mapGroup[restraint.Group] || "RopeHarness",
					factionFilters: {
						Rope: {color: "Highlight", override: true},
					},
				}
			);
			return ret;
		}
	},
};


/**
 * Bestows an event-type curse onto an item by adding events
 * @param item
 * @param ev
 */
function KDBestowCurse(item: item, ev: KinkyDungeonEvent[]): void {
	// Sanitize to avoid duped pointer
	ev = JSON.parse(JSON.stringify(ev));
	if (!item.events) item.events = [];
	// Add curse to events
	for (let e of Object.values(ev)) {
		e.curse = true;
		item.events.push(e);
	}
}

/**
 * Sets the curse for an item returns if success
 */
function KDSetCurse(item: item, curse: string, force: boolean = false): boolean {
	// Sanitize to avoid duped pointer
	if (item.type == LooseRestraint) {
		if (!force && item.curse) {
			return false;
		}
		item.curse = curse;
		let variant = KDGetRestraintVariant(item);
		if (variant) variant.curse = curse;
	} else if (item.type == Restraint) {
		if (!force && item.curse) {
			return false;
		}
		let prevCurse = item.curse;
		if (item.curse) {
			if (KDCurses[item.curse]) {
				let unlock = true;//KDCurses[item.curse].alwaysRemoveOnUnlock || !KDGroupBlocked(KDRestraint(item).Group);
				let res = KDCurses[item.curse].remove(item, KDGetItemLinkHost(item), false);
				if (typeof res === "boolean") {
					unlock = res;
				}
				KinkyDungeonSendEvent("removeCurse", {
					curse: item.curse,
					unlock: unlock,
					result: res,
					item: item,
				});
			}
		}
		item.curse = curse;
		let variant = KDGetRestraintVariant(item);
		if (variant) variant.curse = curse;
		if (!curse) return;
		if (KDCurses[curse] && KDCurses[curse].onApply) {
			KDCurses[curse].onApply(item, KDGetItemLinkHost(item));
			KinkyDungeonSendEvent("addCurse", {
				prevCurse: prevCurse,
				curse: item.curse,
				item: item,
			});
		}
		return true;
	}
	return false;
}

/**
 * @param restraint
 * @param newRestraintName
 * @param ev
 * @param power
 * @param lock
 * @param enemyTags
 * @param noPick
 */
function KDAddEventVariant(restraint: restraint, newRestraintName: string, ev: KinkyDungeonEvent[], power: number = 4, lock: string = undefined, enemyTags: Record<string, number> = {basicCurse: 10}, noPick: boolean = true): any {
	// Sanitize to avoid duped pointer
	ev = JSON.parse(JSON.stringify(ev));
	KinkyDungeonDupeRestraintText(restraint.name, newRestraintName);
	let events: KinkyDungeonEvent[] = ev.concat(restraint.events);
	let escapeChance = Object.assign({}, restraint.escapeChance);
	Object.assign(escapeChance, {
		Struggle: Math.min(restraint.escapeChance.Struggle, -0.2),
		Cut: Math.min(restraint.escapeChance.Cut || 1.0, -0.1),
	});
	if (!noPick) {
		Object.assign(escapeChance, {
			Pick: Math.min(restraint.escapeChance.Pick || 0, 0.1),
		});
	}
	return {
		//protection: 0,
		preview: restraint.preview || restraint.name,
		original: restraint.name,
		protectionCursed: true,
		escapeChance: escapeChance,
		DefaultLock: lock == undefined ? restraint.DefaultLock : lock,
		HideDefaultLock: lock != restraint.DefaultLock || restraint.HideDefaultLock,
		magic: true,
		events: events,
		power: power,
		good: false,
		enemyTags: Object.assign({}, enemyTags),
		shrine: restraint.shrine?.concat(["Cursed"]),
		inventoryAsSelf: restraint.inventoryAsSelf || restraint.inventoryAs || restraint.name,
		displayPower: restraint.displayPower || restraint.power,
	};
}

function KinkyDungeonCurseInfo(item: item, Curse: string) {
	if (Curse == "MistressKey" && KinkyDungeonItemCount("MistressKey")) {
		KinkyDungeonSendActionMessage(4, TextGet("KinkyDungeonCurseInfoMistressKeyHave").replace("KeyAmount", "" + KinkyDungeonItemCount("MistressKey")), KDBaseWhite, 2);
	} else if (KDCurses[Curse].customInfo) {
		KDCurses[Curse].customInfo(item, Curse);
	} else {
		KinkyDungeonSendActionMessage(4, TextGet("KinkyDungeonCurseInfo" + Curse), KDBaseWhite, 2);
	}
}

function KinkyDungeonCurseStruggle(item: item, Curse: string) {
	if (Curse == "MistressKey") {
		KinkyDungeonSendActionMessage(4, TextGet("KinkyDungeonCurseStruggle" + Curse + item.name), KDBaseWhite, 2);
	} else if (KDCurses[Curse].customStruggle) {
		KDCurses[Curse].customStruggle(item, Curse);
	} else {
		KinkyDungeonSendActionMessage(4, TextGet("KinkyDungeonCurseStruggle" + Curse), KDBaseWhite, 2);
	}
}

function KinkyDungeonCurseAvailable(item: item, Curse: string) {
	if (KDCurses[Curse] && KDCurses[Curse].condition(item)) {
		return (KDCurses[Curse].blockable && (
			KDGroupBlocked(KDRestraint(item)?.Group)
			|| !KDIsItemAccessible(item)
		)) ? "Blocked" : "";
	}
	return "FailCondition";
}

/**
 * @param group
 * @param index
 * @param Curse
 */
function KinkyDungeonCurseUnlock(group: string, index: number, Curse: string) {
	let unlock = true;
	let keep = true;
	let restraint = KinkyDungeonGetRestraintItem(group);
	let host = restraint;
	if (index) {
		let surfaceItems = KDDynamicLinkListSurface(restraint);
		if (surfaceItems[index]) {
			host = surfaceItems[index - 1];
			restraint = surfaceItems[index];
		}
		else console.log("Error! Please report the item combination and screenshot to Ada!");
	}

	let inventoryAs = restraint.inventoryVariant || restraint.name || (KDRestraint(restraint).inventoryAs);
	restraint.curse = undefined;
	if (inventoryAs && KinkyDungeonRestraintVariants[inventoryAs]) {
		KinkyDungeonRestraintVariants[inventoryAs].curse = undefined;
	}

	if (KDCurses[Curse]) {
		//unlock = KDCurses[Curse].alwaysRemoveOnUnlock || !KDGroupBlocked(group);
		let res = KDCurses[Curse].remove(restraint, host, false);
		if (typeof res === "boolean") {
			unlock = res;
		}
		
		KinkyDungeonSendEvent("removeCurse", {
			curse: Curse,
			unlock: unlock,
			result: res,
			item: resizeBy,
		});
	}

	if (unlock) {
		KDSendStatus('escape', KinkyDungeonGetRestraintItem(group).name, "Curse");
		KinkyDungeonSendActionMessage(8, TextGet("KinkyDungeonCurseUnlock" + Curse), "#99FF99", 2);
		KinkyDungeonRemoveRestraintSpecific(restraint, keep, undefined, false, false, false, KinkyDungeonPlayerEntity);
	}


}

/**
 * @param curse
 */
function KDCursePower(curse: string): number {
	if (KDCurses[curse]) {
		return KDCurses[curse].powerBoost || 5;
	}
	return 0;
}

/**
 * @param curse
 */
function KDCurseMult(curse: string): number {
	if (KDCurses[curse]) {
		return KDCurses[curse].powerMult || 3;
	}
	return 1;
}

type KDSkimpyReplacer = (ret, restraint: restraint, newRestraintName: string) => any

let KDSkimpyModelReplace: Record<string, KDSkimpyReplacer> = {
	ChainSkirtRestraint: (ret, restraint, newRestraintName) => {
		ret.enemyTags = {skimpyCurse: 10};
		ret.Model = "ChainPanties";
		ret.remove = ["ClothLower", "Skirts", "Pants"];
		if (restraint.addPose) {
			ret.addPose = [...restraint.addPose, "SkimpyLower"];
		} else ret.addPose = ["SkimpyLower"];
		return ret;
	},
	ChainSkirt2Restraint: (ret, restraint, newRestraintName) => {
		ret.enemyTags = {skimpyCurse: 10};
		ret.Model = "ChainPanties2";
		ret.remove = ["ClothLower", "Skirts", "Pants"];
		if (restraint.addPose) {
			ret.addPose = [...restraint.addPose, "SkimpyLower"];
		} else ret.addPose = ["SkimpyLower"];
		return ret;
	},
	ChainTunicRestraint: (ret, restraint, newRestraintName) => {
		ret.enemyTags = {skimpyCurse: 10};
		ret.Model = "ChainBikini";
		ret.remove = ["Cloth", "Shirts"];
		if (restraint.addPose) {
			ret.addPose = [...restraint.addPose, "SkimpyUpper"];
		} else ret.addPose = ["SkimpyUpper"];
		return ret;
	},
}

let KDRopeMapByGroup = {
	ItemTorso: "RopeHarness",
	ItemPelvis: "RopeCrotch",
	ItemLegs: "RopeCrotch",
	ItemArms: "RopeChestStraps2",
	ItemBreast: "RopeChestStraps2",
}